module.exports = __webpack_public_path__ + "082c463cdb3456c065689a71216adf47.fbx";